export default {
  "removeItem": "Supprimer l'article",
  "addItem": "Ajouter",
  "invalidClubCodeForInRoomScreenRoute": "Code de club invalide pour la route d'écran dans la chambre",
  "screenNotProvisionedMissingClubCodeDeviceCode": "Ecran non fourni / manquant clubCode / appareilCode",
  "screenNotFound": "Écran non trouvé",
  "unableToStartProvisioning": "Incapable de commencer à fournir",
  "waitingForProvisioning": "J'attends la fourniture...",
  "memberMode": "Mode Membre",
  "yourPrivateSanctuary": "Votre sanctuaire privé",
  "communication": "Communication",
  "bookings": "Réservations",
  "diningDrinks": "Restauration et boissons",
  "activities": "Activités",
  "roomService": "Chambre Service",
  "message": "Message",
  "contactConciergeStaff": "Contact concierge & personnel",
  "reservations": "Réservations",
  "viewAndAdjustUpcomingBookings": "Voir et ajuster les réservations à venir",
  "orderDrinks": "Commandez des boissons",
  "seeOurMenus": "Voir nos menus",
  "planActivities": "Plan Activités",
  "exploreOurAmenities": "Explorez nos équipements",
  "callFrontDesk": "Réception",
  "golfTeeTimes": "Départs de golf",
  "spaRitual": "rituel spa",
  "fitnessSession": "Session de conditionnement physique",
  "racquetCourt": "Cour de raquette",
  "dining": "Salle à manger",
  "signatureCocktails": "cocktails signature",
  "wineList": "Liste des vins",
  "inRoomDining": "Salle à manger",
  "eventsCalendar": "Calendrier des manifestations",
  "guidedTours": "Visites guidées",
  "wellnessSchedule": "Calendrier de bien-être",
  "localHighlights": "Faits saillants locaux",
  "breakfast": "Petit déjeuner",
  "lateNightBites": "Morsures de nuit tardives",
  "housekeepingRequest": "Demande d ' entretien",
  "welcomeBack": "Bienvenue.",
  "welcome": "Bienvenue.",
  "messageFrontDesk": "Réception de messages",
  "missingClub": "Le club manquant",
  "unableToPlaceTheCall": "Impossible de passer l'appel.",
  "roomUnavailable": "Chambre non disponible",
  "noRoomIsAssignedToThisScreen": "Aucune pièce n'est assignée à cet écran.",
  "frontDeskCallingIsntConfiguredYet": "L’appel à la réception n’est pas encore configuré.",
  "unableToPlaceCall": "Incapable d'appeler",
  "pleaseTryAgainSoon": "S'il vous plaît essayez à nouveau bientôt.",
  "callingFrontDesk": "Appel à la réception...",
  "connectingYourRequest": "Connectez votre demande.",
  "unableToHangUp": "Incapable de raccrocher",
  "pleaseTryAgain": "Veuillez réessayer.",
  "messageFailed": "Message échoué",
  "item": "Article",
  "orderPlaced": "Commande placée · #",
  "roomServiceHasReceivedYourRequest": "Le service en chambre a reçu votre demande.",
  "pleaseReviewYourOrderAndTryAgain": "Veuillez revoir votre commande et réessayer.",
  "menuIsNoLongerAvailable": "Le menu n'est plus disponible.",
  "orderRetryConflictPleaseTryAgain": "Recommencez le conflit.",
  "unableToPlaceOrder": "Incapable de passer la commande",
  "pleaseTryAgainInAMoment": "Veuillez réessayer dans un instant.",
  "room": "Chambre",
  "deviceDisabled": "Dispositif désactivé",
  "thisScreenIsDisabledAskStaffToEnableItInTheClubPortal": "Cet écran est désactivé. Demandez au personnel de l'activer dans le portail du club.",
  "screenAlreadyPaired": "Écran déjà apparié",
  "thisScreenIsAlreadyPairedToClub": "Cet écran est déjà apparié au club",
  "device": ", dispositif",
  "openInRoomScreen": "Ouvrez l'écran en chambre",
  "pairAnotherScreen": "Paire un autre écran",
  "screenProvisioning": "Mise à disposition d ' un écran",
  "installID": "Installer ID:",
  "shareThisCodeWithClubStaffToClaimThisScreen": "Partagez ce code avec le personnel du club pour réclamer cet écran.",
  "expiresIn": "Expirant",
  "staffInstructions": "Instructions du personnel",
  "openTheClubPortalRoomsInRoomScreens": "Ouvrez le portail du club  ⁇  Rooms  ⁇  In-Room Screens.",
  "clickAddScreenAndEnterThisCode": "Cliquez sur « Ajouter l'écran » et entrez ce code.",
  "selectTheRoomToAssignAndSubmit": "Sélectionnez la chambre à attribuer et à soumettre.",
  "status": "État :",
  "waitingForAClubAdminToClaimThisScreenTheDisplayWillAutomaticallyContinueOnceAssigned": "En attente d'un administrateur de club pour réclamer cet écran. L'affichage va automatiquement continuer une fois assigné.",
  "suiteBackdrop": "Fond de la suite",
  "privacy": "Vie privée",
  "home": "Maison",
  "wellNotifyYouWhenItsReady": "Nous vous avertirons quand c'est prêt.",
  "memberPortal": "Portail des membres",
  "bookingsMessagingAndSchedulesStayAvailable": "Les réservations, les messages et les horaires restent disponibles.",
  "backToHome": "Retour à l’accueil",
  "signOutOnThisScreen": "S'identifier sur cet écran",
  "memberPortalModulesRenderHereInProductionThisPlaceholderKeepsTheLayoutConsistentWhileThePairingSessionIsActive": "Les modules de portails de membres rendent ici dans la production. Ce porteur maintient la mise en page cohérente pendant que la session de jumelage est active.",
  "bookingShortcuts": "Shortcuts de réservation",
  "messagesConcierge": "Messages et conciergerie",
  "liveChatWithTheFrontDeskTeam": "Dialogue en direct avec l'équipe de réception.",
  "back": "Retour",
  "typeYourMessage": "Tapez votre message...",
  "send": "Envoyer",
  "refinedOptionsCuratedForYourStay": "Options améliorées pour votre séjour.",
  "inCallWithFrontDesk": "En appel avec la réception",
  "callEnded": "Appel terminé",
  "tapToContinue": "Appuyez sur le bouton pour continuer",
  "enter": "Entrez.",
  "hangUp": "Accroche-toi.",
  "confirmRoomServiceOrder": "Confirmer la commande de service de chambre",
  "reviewYourItemsBeforePlacingTheOrder": "Vérifiez vos articles avant de passer la commande.",
  "subtotal": "Sous-total",
  "deliveryFee": "Frais de livraison",
  "total": "Total",
  "cancel": "Annuler",
  "placingOrder": "Placer l'ordre...",
  "confirmOrder": "Confirmer la commande",
  "pairDevice": "Appareillage paire",
  "syncWithYourPhone": "Synchronisation avec votre téléphone",
  "pairingCode": "Code de paire",
  "menus": "Menus",
  "loadingMenus": "Charger les menus...",
  "noRoomServiceMenusAvailable": "Pas de menus de service de chambre disponibles.",
  "items": "Articles",
  "loadingItems": "Chargement des articles...",
  "basket": "Panier",
  "noItemsYet": "Pas encore d'articles.",
  "placeOrder": "Ordonnance",
  "loading": "chargement...",
  "requested": "demandée",
  "confirmed": "confirmé",
  "preparing": "préparation",
  "ready": "prêt",
  "delivered": "livrés livrés",
  "cancelled": "annulé"
};
